
$('document').ready(function () {

    if ($('#tutos_v2_android').length > 0) {
        //permet de changer la couleur des liens cliqués

        function handleClickLink(link) {
            $('a').removeClass('active');
            link.toggleClass('active', true);
        }

        //Cette partie concerne directement les liens du menu
        $('#tutos_android_menu a').click(function (e) {
            e.preventDefault();
            handleClickLink($(this));
            $('#tutos_content .tutos_section:visible').hide();
            var id = $(this).data('tutos');
            $('#' + id).show();
            if ($('#isMobile').is(':hidden')) {
                window.scrollTo(0, 0);
            } else {
                $('html, body').animate({
                    scrollTop: ($('#ancre').offset().top)
                }, 250);
            }
        });

        //Cette partie a été ajoutée pour prendre en compte les
        //liens qui sont dans le contenu
        $('.tutos_section a:not([rel="external"])','#tutos_v2_android').click(function (e) {
            e.preventDefault();
            var id = $(this).data('tutos');
            $('[data-tutos='+id+']', '#tutos_android_menu').trigger('click');
        });

        //Mise en couleur du lien dans le menu correspondant au contenu affiché au chargement de la page
        $('#headingFirst a').trigger('click');
    }

});
